var map = {
	"./CCAMX45.png": "zzNu",
	"./CCCal45.png": "op6t",
	"./CCIsracard45.png": "I14C",
	"./CCLeumi45.png": "Toa0",
	"./discount.svg": "LaDc",
	"./doar.svg": "8j1F",
	"./egud.svg": "43Su",
	"./habeinleumi.svg": "yxZ8",
	"./hapoalim.svg": "tGW7",
	"./leumi.svg": "OCvp",
	"./massad.svg": "Vh71",
	"./mercantile.png": "7bvC",
	"./mizrachi.svg": "Iam3",
	"./otsar.png": "khoE",
	"./pagi.png": "aeL4",
	"./ubank.png": "/bmm"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "u8Js";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos-30 ^\.\/.*$
// module id = u8Js
// module chunks = 6